import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CONSTANTES } from "../shared/global";
import { BlockApp } from '../models/BlockApp';

@Injectable({
    providedIn: 'root'
})
export class BlockService {

    public url: string;

    constructor(private http: HttpClient) {
        this.url = CONSTANTES.api_url + "/blocks";
    }


    getBlockApp() {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.get<BlockApp>(this.url + "/get", { headers: iheaders })
    }

    postBlockApp(block : BlockApp) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<BlockApp>(this.url + "/save",JSON.stringify(block), { headers: iheaders })
    }
}
